import { render, staticRenderFns } from "./SalesCustomerDrawer.vue?vue&type=template&id=c8a70176&"
import script from "./SalesCustomerDrawer.vue?vue&type=script&lang=js&"
export * from "./SalesCustomerDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports